<div data-testid="change-approval-page" class="p-6 change-approval-container flex-table-page">
  <!-- Header with Tabs -->
  <div class="mb-6 flex-table-header">
    <h2 class="text-2xl font-semibold text-gray-800 mb-4">
      {{ "inventory_change_approval.title" | translate }}
    </h2>

    <!-- Tab Navigation -->
    <div class="flex border-b border-gray-200">
      <button
        data-testid="change-approval-tab-virtual"
        class="px-6 py-3 text-sm font-medium border-b-2 transition-colors"
        [class]="
          activeTab() === 'virtual'
            ? 'border-blue-500 text-blue-600'
            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
        "
        (click)="onTabChange('virtual')"
      >
        {{
          "inventory_change_approval.tabs.virtual_warehouse_transfer_review"
            | translate
        }}
      </button>
      <button
        data-testid="change-approval-tab-inventory"
        class="px-6 py-3 text-sm font-medium border-b-2 transition-colors"
        [class]="
          activeTab() === 'inventory'
            ? 'border-blue-500 text-blue-600'
            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
        "
        (click)="onTabChange('inventory')"
      >
        {{
          "inventory_change_approval.tabs.inventory_reservation_review"
            | translate
        }}
      </button>
      <button
        data-testid="change-approval-tab-sub-warehouse"
        class="px-6 py-3 text-sm font-medium border-b-2 transition-colors"
        [class]="
          activeTab() === 'sub-warehouse'
            ? 'border-blue-500 text-blue-600'
            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
        "
        (click)="onTabChange('sub-warehouse')"
      >
        {{
          "inventory_change_approval.tabs.sub_warehouse_plan_review" | translate
        }}
      </button>
    </div>
  </div>

  <!-- Search Form -->
  <app-search-form
    data-testid="change-approval-search-form"
    [searchFormat]="searchFormat()"
    (formSearch)="onSearch($event)"
    (formReset)="onReset()"
  ></app-search-form>

  <!-- Data Table -->
  <div class="flex-table-section">
    <app-data-table
      data-testid="change-approval-table"
      [dataSource]="dataSource()"
      [columns]="columns"
      [rows]="rows()"
      [first]="first()"
      [totalRecords]="totalRecords()"
      [loading]="loading()"
      scrollHeight="flex"
      (pageChange)="onPageChange($event)"
    >
    <!-- Status Template -->
    <ng-template #statusTemplate let-status let-record>
      <div class="status-cell">
        <span [class]="getStatusClass(status)">
          {{ formatTransferStatus(status) }}
        </span>
      </div>
    </ng-template>

    <!-- Custom Template for Creation Time -->
    <ng-template
      #customTemplate
      let-value
      let-record="rowData"
      let-column="column"
    >
      @if (column.prop === "creationTime") {
        <div class="flex items-center justify-center">
          <span class="text-sm text-gray-600">
            {{ formatDate(record.creationTime) }}
          </span>
        </div>
      } @else {
        <div class="flex items-center justify-center">
          {{ value }}
        </div>
      }
    </ng-template>

    <!-- Custom Actions Template -->
    <ng-template #actionsTemplate let-record>
      <div class="flex gap-2 justify-center">
        <span
          [attr.data-testid]="'change-approval-action-approve-' + record.id"
          (click)="onApprove(record)"
          class="action-link action-approve cursor-pointer"
        >
          {{ "common.actions.approve" | translate }}
        </span>

        <span
          [attr.data-testid]="'change-approval-action-reject-' + record.id"
          (click)="onReject(record)"
          class="action-link action-reject cursor-pointer"
        >
          {{ "common.actions.reject" | translate }}
        </span>

        <span
          [attr.data-testid]="'change-approval-action-delete-' + record.id"
          (click)="onDelete(record)"
          class="action-link action-delete cursor-pointer"
        >
          {{ "common.actions.delete" | translate }}
        </span>
      </div>
    </ng-template>
    </app-data-table>
  </div>

  <!-- Toast Messages -->
  <p-toast data-testid="change-approval-toast"></p-toast>
</div>

<!-- Shared Confirmation Dialog -->
<app-confirmation-dialog
  [testId]="'change-approval-confirmation-dialog'"
  [(visible)]="showConfirmationDialog"
  [title]="dialogTitle"
  [message]="dialogMessage"
  [buttons]="dialogButtons"
  (emitOnClick)="onConfirmatiButtonClick($event)"
></app-confirmation-dialog>
